import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
import { linkifyText } from './linkify';
import './MobileLegalShell.css';

const APP_VERSION = '1.0.0';

export default function MobileTermsOfLicensePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [paragraphs, setParagraphs] = useState([]);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/settings/content/terms-conditions`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      let list = [];
      try {
        list = JSON.parse(data.content || '[]');
      } catch {
        list = data.content ? [String(data.content)] : [];
      }
      if (Array.isArray(list)) {
        setParagraphs(list.map((p) => String(p)));
      } else {
        setParagraphs([String(data.description || '')]);
      }
    } catch {
      setParagraphs([
        'This agreement is between you and the operator of this platform. By using the application or related services, you agree to be bound by these terms.',
        '1. Acceptance: By accessing the service, you confirm that you can enter into a binding agreement and you accept the Terms, Privacy Policy, and any policies referenced here.',
        '2. Changes: We may update these terms from time to time. The revised version will be posted in the app; continued use after changes constitutes acceptance.',
        '3. Limited use: The application is licensed for your personal or internal business use in line with our policies, not for resale or unauthorized redistribution.'
      ]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="mlegal-page">
      <header className="mlegal-header">
        <button type="button" className="mlegal-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mlegal-title mlegal-title--upper">Terms of License and Use</h1>
      </header>
      <div className="mlegal-scroll">
        {loading ? (
          <p className="mlegal-loading">Loading…</p>
        ) : (
          <div className="mlegal-body">
            {paragraphs.map((p, idx) => (
              <p key={idx}>{linkifyText(p)}</p>
            ))}
          </div>
        )}
        <div className="mlegal-foot-version">V {APP_VERSION}</div>
      </div>
    </div>
  );
}
